export default __webpack_public_path__ + "static/media/avatar-5.b309bbe2.jpg";